import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-691567b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "micro-row" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "vertical" }
const _hoisted_6 = ["href", "title"]
const _hoisted_7 = { title: "Validated by authors" }
const _hoisted_8 = {
  key: 1,
  class: "second-row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Paper title:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Authors:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Date:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Paper DOI:", -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lien UGA cloud:", -1))
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Grasp(s): ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Object(s): ", -1))

import MicroGesture from '@/components/Microgesture/MicrogestureComponent'
import ExportLatexButton from '@/components/Latex/ExportLatexButton'
import ImageModal from '@/components/Table/ImageModal'
import CopyMicrogestureButton from '@/components/UI/CopyButtonComponent'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import store from '@/store'


export default {
  __name: 'MicroRow',
  props: {
    paper: Object,
    microgesture: Object,
    options: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup(__props) {

const router = useRouter()



const complete = ref(false)

function getSmallAuthors (authors) {
  const author = authors.split(',')[0]
  return `${author} et al.`
}

function getAuthors (authors) {
  const authorList = authors.split(' and ').map(x => x.split(', '))
  let s = ''
  for (const [i, author] of authorList.entries()) {
    s += `${author[1].slice(0, 1)}. ${author[0]}`
    if (i < authorList.length - 2) {
      s += ', '
    } else if (i === authorList.length - 2) {
      s += ' and '
    }
  }
  return s
}

function isReaderImplemented (m) {
  const microgestureToGlyph = (m) => {
    if (m.type === 'in-construction') {
      return ''
    }
    if (m.type === 'glyph') {
      let finger1, finger2
      if (m.actuator.length === 0) {
        finger1 = 'index'
      } else {
        finger1 = m.actuator[0].join('-')
      }
      if (m.contact && m.contact.action === 'Object') throw Error('not implemented')
      if (m.contact && m.contact.actuator && m.contact.actuator.length > 0) {
        finger2 = m.contact.actuator[0].join('-')
      } else {
        finger2 = 'thumb'
      }
      if (m.action === 'Any') {
        if (m.context[0] === 'Air' && m.context[1] === 'Contact') {
          return [`${finger1}-${finger2}-Flexion-${m.context[0]}-${m.context[1]}`.toLowerCase()]
        }
        if (m.context[0] === 'Contact' && m.context[1] === 'Air') {
          return [`${finger1}-${finger2}-Extension-${m.context[0]}-${m.context[1]}`.toLowerCase()]
        }
      }
      return [`${finger1}-${finger2}-${m.action}-${m.context[0]}-${m.context[1]}`.toLowerCase()]
    } else if (m.type === 'then') {
      const temp = []
      for (const x of m.operands) {
        temp.push(...microgestureToGlyph(x))
      }
      return temp
    } else if (['and', 'or'].includes(m.type)) {
      throw Error('not implemented')
    } else if (m.type === 'seq') {
      throw Error('not implemented')
    }
  }

  try {
    const implemented = ['index-thumb-flexion-air-contact', 'index-thumb-flexion-contact-contact', 'index-thumb-flexion-contact-air', 'middle-thumb-flexion-air-contact', 'index-middle-thumb-flexion-air-contact', 'index-thumb-extension-contact-air', 'middle-thumb-extension-contact-air', 'index-middle-thumb-extension-contact-air']
    const micro = microgestureToGlyph(m)
    for (const x of micro) {
      if (!implemented.includes(x)) throw new Error()
    }
    return true
  } catch (e) {
    return false
  }
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", {
      class: "microgesture-name",
      onClick: _cache[1] || (_cache[1] = $event => (complete.value = !complete.value))
    }, [
      (!complete.value && !__props.options.noSecondRow)
        ? (_openBlock(), _createBlock(_component_unicon, {
            key: 0,
            name: "angle-down"
          }))
        : (!__props.options.noSecondRow)
          ? (_openBlock(), _createBlock(_component_unicon, {
              key: 1,
              name: "angle-right"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_2)),
      _createElementVNode("span", null, [
        _createElementVNode("b", null, _toDisplayString(__props.microgesture.name), 1),
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(getSmallAuthors(__props.paper.authors)), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(__props.paper.date), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          href: `https://doi.org/${__props.paper.doi}`,
          target: "_blank",
          title: __props.paper.shortTitle
        }, [
          _createVNode(_component_unicon, {
            name: "external-link-alt",
            width: "18",
            height: "18"
          })
        ], 8, _hoisted_6),
        _createElementVNode("span", _hoisted_7, [
          (__props.paper.authorApproved)
            ? (_openBlock(), _createBlock(_component_unicon, {
                key: 0,
                name: "file-check-alt",
                width: "18",
                height: "18"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "microgesture-container",
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
    }, [
      _createVNode(_unref(MicroGesture), {
        modelValue: __props.microgesture.µGlyphe
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(CopyMicrogestureButton), {
        microgesture: __props.microgesture.µGlyphe,
        unicon: "copy"
      }, null, 8, ["microgesture"]),
      (isReaderImplemented(__props.microgesture.µGlyphe))
        ? (_openBlock(), _createBlock(_unref(CopyMicrogestureButton), {
            key: 0,
            microgesture: __props.microgesture.µGlyphe,
            unicon: "play-circle",
            name: "",
            onCopy: _cache[3] || (_cache[3] = $event => (_unref(router).push('/reader')))
          }, null, 8, ["microgesture"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(ExportLatexButton), {
        microgesture: __props.microgesture.µGlyphe
      }, null, 8, ["microgesture"])
    ]),
    _createElementVNode("span", null, [
      (__props.microgesture.textDescription && __props.microgesture.textDescription.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(__props.microgesture.textDescription), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" No textual description ")
          ], 64))
    ]),
    (__props.microgesture.imageDescription)
      ? (_openBlock(), _createBlock(_unref(ImageModal), {
          key: 0,
          microgesture: __props.microgesture
        }, null, 8, ["microgesture"]))
      : _createCommentVNode("", true),
    (!__props.options.noSecondRow && complete.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(__props.paper.title), 1),
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(getAuthors(__props.paper.authors)), 1),
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(__props.paper.date), 1),
          _hoisted_12,
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
            href: `https://doi.org/${__props.paper.doi}`,
            target: "_blank"
          }, _toDisplayString(__props.paper.doi), 9, _hoisted_13),
          (_unref(store).isLogged)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_14,
                (__props.paper.privateUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                      target: "_blank",
                      class: "private-link",
                      href: __props.paper.privateUrl
                    }, _toDisplayString(__props.paper.privateUrl), 9, _hoisted_15))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_16,
          _createElementVNode("span", null, [
            (__props.microgesture.grasp && __props.microgesture.grasp.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(__props.microgesture.grasp.map(x => x[0].toUpperCase() + x.slice(1)).join(', ')), 1)
                ], 64))
              : (__props.microgesture.customGrasp && __props.microgesture.customGrasp.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(__props.microgesture.customGrasp), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" Free-Hand ")
                  ], 64))
          ]),
          (__props.microgesture.grasp && __props.microgesture.grasp.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_17,
                _createElementVNode("span", null, [
                  (__props.microgesture.object)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(__props.microgesture.object.replaceAll(',', ', ')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" No specific object ")
                      ], 64))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}